import React, { cloneElement } from 'react';
import { isElement, createEventHandler } from '@mantine/utils';
import { useMenuContext } from '../Menu.context.js';
import { MENU_ERRORS } from '../Menu.errors.js';
import { Popover } from '../../Popover/Popover.js';

function MenuTarget(_ref) {
  var children = _ref.children,
      _ref$refProp = _ref.refProp,
      refProp = _ref$refProp === void 0 ? "ref" : _ref$refProp;

  if (!isElement(children)) {
    throw new Error(MENU_ERRORS.children);
  }

  var ctx = useMenuContext();
  var onClick = createEventHandler(children.props.onClick, function () {
    return ctx.trigger === "click" && ctx.toggleDropdown();
  });
  var onMouseEnter = createEventHandler(children.props.onMouseEnter, function () {
    return ctx.trigger === "hover" && ctx.openDropdown();
  });
  var onMouseLeave = createEventHandler(children.props.onMouseLeave, function () {
    return ctx.trigger === "hover" && ctx.closeDropdown();
  });
  return /* @__PURE__ */React.createElement(Popover.Target, {
    refProp: refProp,
    popupType: "menu"
  }, cloneElement(children, {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-expanded": ctx.opened ? true : void 0
  }));
}

MenuTarget.displayName = "@mantine/core/MenuTarget";
export { MenuTarget };